module.exports = __webpack_public_path__ + "static/img/7.6a5dd6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/7.png
// module id = XLvB
// module chunks = 0